import Vue from 'vue';

/**
 * Global filters
 */

 Vue.filter("date", (value) => {

     if ( typeof value == 'string' && value.trim() != '' ) {
         let date = new Date(value);

         if ( isNaN(date.getTime()) === false ) {
             return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'});
         }
     }

     return '-';
 });

 Vue.filter("prettydate", (value) => {

     if ( typeof value == 'string' && value.trim() != '' ) {
         let date = new Date(value);

         if ( isNaN(date.getTime()) === false ) {
             return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'long', year: 'numeric'});
         }
     }

     return '-';
 });

 Vue.filter("datestring", (value) => {

     let date = value;

     if ( typeof value == 'string' && value.trim() != '' ) {
         date = new Date(value);
     }

     if ( isNaN(date.getTime()) === false ) {

         let day = String(date.getDate()).padStart(2, '0');
         let month = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
         let year = date.getFullYear();

         return year + '-' + month + '-' + day;
     }

     return '-';
 });

 Vue.filter("time", (value) => {

     if ( typeof value == 'string' && value.trim() != '' ) {
         let date = new Date(value);

         if ( isNaN(date.getTime()) === false ) {
             return  date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
         }
     }

     return '-';
 });

Vue.filter("datetime", (value) => {

    if ( typeof value == 'string' && value.trim() != '' ) {
        let date = new Date(value);

        if ( isNaN(date.getTime()) === false ) {

            return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})
                    + ' ' + date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });

        }
    }

    return '-';
});

Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('lower', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.toLowerCase();
});

Vue.filter('upper', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.toUpperCase();
});
